import {DATE_FORMAT} from 'consts'
import moment from 'moment'
import {Basic, Ventrata} from 'types'
import {convertUnitItemsToUnitCounterMap} from './convertUnitItemsToUnitCounterMap'
import {getHumanPrice} from './getHumanPrice'
import {getPricingByCurrency} from './getPricingByCurrency'

const getPriceRange = (price: number | null | undefined) => {
  const humanPrice = getHumanPrice(price)

  let i = 1

  while (humanPrice > i * 50) {
    i++
  }

  return `${(i - 1) * 50}-${i * 50}`
}

export const getGa4BookingItems = (
  booking: Ventrata.Booking,
  currency: Basic.Currency,
  crossSellingFlag: boolean,
  precalculatedUnitCounterMap?: Basic.UnitCounterMap
) => {
  const unitCounterMap = precalculatedUnitCounterMap || convertUnitItemsToUnitCounterMap(booking.unitItems)

  const items = []

  for (const unitId of Object.keys(unitCounterMap)) {
    const unit = booking.option.units.find((unit) => unit.id === unitId)

    if (!unit) {
      throw new Error(`Can't find unit by id '${unitId}'`)
    }

    const pricingSource = booking.product.pricingPer === 'BOOKING' ? booking.option : unit
    const pricing = getPricingByCurrency(pricingSource.pricing, currency)
    const availabilityIdMoment = moment(booking.availabilityId)

    items.push({
      item_id: unit.id,
      item_name: booking.product.title,
      item_variant: booking.option.title,
      item_category: unit.title,
      item_category2: availabilityIdMoment.format(DATE_FORMAT),
      item_category3: availabilityIdMoment.format('HH:mm:ss'),
      crossSell: crossSellingFlag,
      item_brand: '',
      item_destination: booking.product.location,
      tour_country: booking.product.country,
      tour_price_range: getPriceRange(pricing?.original),
      tour_reviews: '20',
      tour_stars: '4.5',
      tour_duration: '2',
      price: getHumanPrice(pricing?.retail),
      discount: getHumanPrice((pricing?.original || 0) - (pricing?.retail || 0)),
      quantity: unitCounterMap[unit.id],
      checkout_type: 'custom_checkout',
    })
  }

  return items
}
